import React, { useState, useEffect, Fragment } from 'react';
import firstImage from '../images/primero.png';
import secondImage from '../images/segundo.png';
import thirdImage from '../images/tercero.png';
import { Link, useNavigate } from 'react-router-dom';
import TwoButtons from '../components/twoButtons';
import SelectorJornada, { puntosEn, filasDeJornada } from '../components/selectorJornada';
import { useRevelacion, claseRevelable } from '../components/revelacion';
import arrow from '../images/arrow-white.png';

const sortByMonth = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.month !== a.month) {
            return b.month - a.month;
        } else if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else {
            return b.last_batch_points - a.last_batch_points;
        }
    });
};
const sortByTotal = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.wines - a.wines;
        }
    });
};
const sortByWine = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.last_wine_points !== a.last_wine_points) {
            return b.last_wine_points - a.last_wine_points;
        } else if (b.last_batch_points !== a.last_batch_points) {
            return b.last_batch_points - a.last_batch_points;
        } else {
            return b.total_points - a.total_points;
        }
    });
};
const sortByTanda = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.last_batch_points !== a.last_batch_points) {
            return b.last_batch_points - a.last_batch_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.total_points - a.total_points;
        }
    });
};
export default function Ranking() {
    const [winegangData, setWinegangData] = useState([]);
    const [selectedButton, setSelectedButton] = useState('General');
    const [vista, setVista] = useState('liga'); // la liga o el id de una jornada
    const revelacion = useRevelacion(); // la jornada que se esta desvelando, si hay
    const navigate = useNavigate();

    const fetchWinegangData = () => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/winegangs`;
        //const url = `http://wineapi/api/winegangs`;

        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    const winegangs = JSON.parse(this.responseText);

                    // Ordenar las winegangs por puntos en month de mayor a menor inicialmente
                    sortByTotal(winegangs);

                    setWinegangData(winegangs);
                    console.log("Datos de las winegangs:", winegangs);
                } else {
                    console.error("Error al obtener los datos de las winegangs:", this.status, this.responseText);
                }
            }
        };
        xhr.send();
    };

    useEffect(() => {
        fetchWinegangData();
    }, []);

    // Al empezar a desvelarse una jornada se vuelven a pedir los datos (su ultimo
    // vino se acaba de cerrar), y al acabar la pantalla se queda en ella
    const idRevelacion = revelacion ? revelacion.id : null;
    useEffect(() => {
        if (idRevelacion) {
            fetchWinegangData();
            setVista(String(idRevelacion));
        }
    }, [idRevelacion]);

    useEffect(() => {
        let sortedWinegangs = [...winegangData];
        if (selectedButton === 'Mensual') {
            sortByMonth(sortedWinegangs);
        } else if (selectedButton === 'General') {
            sortByTotal(sortedWinegangs);
        } else if (selectedButton === 'Tanda') {
            sortByTanda(sortedWinegangs);
        } else if (selectedButton === 'Vino') {
            sortByWine(sortedWinegangs);
        }
        setWinegangData(sortedWinegangs);
    }, [selectedButton]);

    const redirectToUserPage = (winegangId) => {
        navigate(`/gangs/${winegangId}`);
    };

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
    };
    const [hoveredDiv, setHoveredDiv] = useState(null);

    const handleMouseEnter = (divName) => {
        setHoveredDiv(divName);
    };

    const handleMouseLeave = () => {
        setHoveredDiv(null);
    };
    // Mientras se desvela una jornada, la clasificacion se queda en ella
    const vistaActiva = revelacion ? String(revelacion.id) : vista;

    // El podio va por la vista elegida (en la liga, por el total, ordene como se
    // ordene la tabla), y solo con quien tiene puntos
    const enLiga = vistaActiva === 'liga';
    let podium = enLiga ? [...winegangData] : filasDeJornada(winegangData, vistaActiva);
    if (enLiga) sortByTotal(podium);
    podium = podium.filter((winegang) => puntosEn(vistaActiva, winegang) > 0);

    // En una jornada, solo las que jugaron en ella y una sola columna de puntos
    const filas = enLiga ? winegangData : filasDeJornada(winegangData, vistaActiva);

    return (
        <div className="winegangs-container">
            <div className="ranking-container">
                <h2>Clasificación</h2>
                <SelectorJornada vista={vista} onChange={setVista} fija={revelacion} />
                <div className="row">
                    <div className="col-sm-4 ranking-second">
                        <img src={secondImage} alt="Segundo" className="ranking-image" />
                        {podium.length > 1 && (
                            <div className={claseRevelable(revelacion, 2)}>{podium[1].winegang_name} {puntosEn(vistaActiva, podium[1])}</div>
                        )}
                    </div>
                    <div className="col-sm-4 ranking-first">
                        <img src={firstImage} alt="Primero" className="ranking-image" />
                        {podium.length > 0 && (
                            <div className={claseRevelable(revelacion, 1)}>{podium[0].winegang_name} {puntosEn(vistaActiva, podium[0])}</div>
                        )}
                    </div>
                    <div className="col-sm-4 ranking-third">
                        <img src={thirdImage} alt="Tercero" className="ranking-image" />
                        {podium.length > 2 && (
                            <div className={claseRevelable(revelacion, 3)}>{podium[2].winegang_name} {puntosEn(vistaActiva, podium[2])}</div>
                        )}
                    </div>
                </div>
                
                <div className="main-table main-table-ranking-gangs">
                    {hoveredDiv === 'General' && <div className="hovered-info">Total de puntos de la liga</div>}
                    {hoveredDiv === 'Tanda' && <div className="hovered-info">Puntos de la última jornada</div>}
                    {hoveredDiv === 'Vino' && <div className="hovered-info">Puntos del último vino</div>}
                    <div className={'ranking-row title-tab' + (enLiga ? '' : ' una-jornada')}>
                        <div className="title">Pos.</div>
                        <div className="title">Equipos</div>
                        {enLiga ? (
                            <>
                                <div
                                    className="title"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleButtonClick('General')}
                                    onMouseEnter={() => handleMouseEnter('General')}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    Total
                                </div>
                                <div
                                    className="title"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleButtonClick('Tanda')}
                                    onMouseEnter={() => handleMouseEnter('Tanda')}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    Jornada
                                </div>
                                <div
                                    className="title"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleButtonClick('Vino')}
                                    onMouseEnter={() => handleMouseEnter('Vino')}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    Ult. Vino
                                </div>
                            </>
                        ) : (
                            <div className="title">Puntos</div>
                        )}
                    </div>
                    <div className={'ranking-row' + (enLiga ? '' : ' una-jornada')}>
                        {filas.map((winegang, index) => (
                            <Fragment key={winegang.id}>
                                <div className="pos">{index + 1}</div>
                                <button className={'item ' + claseRevelable(revelacion, index + 1)} onClick={() => redirectToUserPage(winegang.id)}>{winegang.winegang_name} ({winegang.members})</button>
                                {enLiga ? (
                                    <>
                                        <div className="item">{winegang.total_points}</div>
                                        <div className="item">{winegang.last_batch_points}</div>
                                        <div className="item">{winegang.last_wine_points}</div>
                                    </>
                                ) : (
                                    <div className={'item ' + claseRevelable(revelacion, index + 1)}>{winegang.jornadas[vistaActiva]}</div>
                                )}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
            <TwoButtons />
        </div>
    );
}
